import { render, staticRenderFns } from "./PaymentHeader.vue?vue&type=template&id=faa1b5d2&scoped=true"
import script from "./PaymentHeader.vue?vue&type=script&lang=ts"
export * from "./PaymentHeader.vue?vue&type=script&lang=ts"
import style0 from "./PaymentHeader.vue?vue&type=style&index=0&id=faa1b5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa1b5d2",
  null
  
)

export default component.exports